'use client';

import { c as _c } from "react/compiler-runtime";
import { PHASE_EXPORT, PHASE_PRODUCTION_BUILD, PHASE_PRODUCTION_SERVER, PHASE_DEVELOPMENT_SERVER, PHASE_TEST, PHASE_INFO } from 'next/constants';
import { scan, setOptions } from 'react-scan';
import { useEffect } from 'react';
import { z } from 'zod';
const variables = {
  ANALYZE: process.env.ANALYZE,
  NEXT_PUBLIC_DEFAULT_LOCALE: process.env.NEXT_PUBLIC_DEFAULT_LOCALE,
  NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID: process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID,
  NEXT_PUBLIC_PROTOCOL: process.env.NEXT_PUBLIC_PROTOCOL,
  NEXT_PUBLIC_SHOPIFY_STORE_DOMAIN: process.env.NEXT_PUBLIC_SHOPIFY_STORE_DOMAIN,
  NEXT_PUBLIC_SHOPIFY_STOREFRONT_ACCESS_TOKEN: process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_ACCESS_TOKEN,
  NEXT_PUBLIC_SHOPIFY_STOREFRONT_API_VERSION: process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_API_VERSION,
  NEXT_PUBLIC_SITE_NAME: process.env.NEXT_PUBLIC_SITE_NAME,
  NODE_ENV: process.env.NODE_ENV,
  PHASE: process.env.PHASE
};
const publicVariablesSchema = z.object({
  NEXT_PUBLIC_DEFAULT_LOCALE: z.string(),
  NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID: z.string(),
  NEXT_PUBLIC_PROTOCOL: z.union([z.literal("http"), z.literal("https")]),
  NEXT_PUBLIC_SHOPIFY_STORE_DOMAIN: z.string(),
  NEXT_PUBLIC_SHOPIFY_STOREFRONT_ACCESS_TOKEN: z.string(),
  NEXT_PUBLIC_SHOPIFY_STOREFRONT_API_VERSION: z.string(),
  NEXT_PUBLIC_SITE_NAME: z.string(),
  NODE_ENV: z.enum(["development", "production", "test"]),
  PHASE: z.enum([PHASE_EXPORT, PHASE_PRODUCTION_BUILD, PHASE_PRODUCTION_SERVER, PHASE_DEVELOPMENT_SERVER, PHASE_TEST, PHASE_INFO])
});
const privateVariablesSchemaClient = z.object({
  ANALYZE: z.undefined()
});
const privateVariablesSchemaServer = z.object({
  ANALYZE: z.stringbool().optional()
});
const envSchema = z.intersection(publicVariablesSchema, typeof window === "undefined" ? privateVariablesSchemaServer : privateVariablesSchemaClient);
const env = envSchema.parse(variables);
function ReactScan() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  return null;
}
function _temp() {
  scan({
    enabled: env.PHASE === PHASE_DEVELOPMENT_SERVER
  });
  setOptions({
    showToolbar: true
  });
}
export { ReactScan };